import { defineStore } from 'pinia';
import http from '../api/httpRequest.js'

export default defineStore('configStore', {
	state: () => {
		return {
			appInit: false,  // 应用是否完成初始化
			electronMode: false, // 当前是否以客户端模式运行
			fullScreen: true, // 当前是否全屏
			app:{},
			appInReview:false, // 是否在审核
			registration: {
				mode: []
			},
			webrtc: {}
		}
	},
	actions: {
		setConfig(config) {
			this.webrtc = config.webrtc;
			this.registration = config.registration;
			this.app = config.app;
		},
		setElectronMode(mode) {
			this.electronMode = mode
		},
		setFullScreen(fullScreen) {
			this.fullScreen = fullScreen;
		},
		setAppInit(appInit) {
			this.appInit = appInit;
		},
		switchFullScreen() {
			this.fullScreen = !this.fullScreen;
		},
		loadConfig() {
			return new Promise((resolve, reject) => {
				const cachedConfig = localStorage.getItem('systemConfig');
				if (cachedConfig) {
					try {
						this.setConfig(JSON.parse(cachedConfig));
						resolve();
						return;
					} catch (error) {
						console.warn('[configStore.loadConfig] 读取系统配置缓存失败:', error);
					}
				}
				http({
					url: '/system/config',
					method: 'GET'
				}).then(config => {
					console.log("系统配置", config)
					this.setConfig(config);
					localStorage.setItem('systemConfig', JSON.stringify(config));
					resolve();
				}).catch((res) => {
					console.warn('[configStore.loadConfig] 获取系统配置失败，使用默认配置:', res);
					resolve();
				});
			})
		}
	}
});
